$('.in-index .products').slick({
  slidesToShow: 4,
 slidesToScroll: 1,
 autoplay: false,
 autoplaySpeed: 3000,
 dots: false,
 arrow: true,
 infinite: false,
 responsive: [
   {
     breakpoint: 991,
     settings: {
       slidesToShow: 3,
       slidesToScroll: 1,
       arrow: true,
       dots: true,
     }
   },
   {
     breakpoint: 767,
     settings: {
      slidesToShow: 2,
      slidesToScroll: 1,

      arrow: true,
      dots: false,
    }
    
   }
   ,
   {
     breakpoint: 600,
     settings: {
      slidesToShow: 1,
      slidesToScroll: 1,

      arrow: true,
      dots: false,
    }
    
   }
 ]
});

$('.type-detail .p-detail>.products-related').slick({
  slidesToShow: 4,
 slidesToScroll: 1,
 autoplay: false,
 autoplaySpeed: 3000,
 dots: false,
 arrow: true,
 infinite: false,
 responsive: [
   {
     breakpoint: 991,
     settings: {
       slidesToShow: 3,
       slidesToScroll: 1,
       arrow: true,
       dots: true,
     }
   },
   {
     breakpoint: 767,
     settings: {
      slidesToShow: 2,
      slidesToScroll: 1,

      arrow: true,
      dots: false,
    }
    
   }
   ,
   {
     breakpoint: 600,
     settings: {
      slidesToShow: 1,
      slidesToScroll: 1,

      arrow: true,
      dots: false,
    }
    
   }
 ]
});